import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { LinkedinShareButton, FacebookShareButton, TwitterShareButton } from 'react-share';

import { Icon } from '@ets-global/b2c-website-ui';

import { useRouter } from '../../../hooks';

import './styles.scss';

const SocialShare = ({ title }) => {
  const { currentRoute, generateUrl } = useRouter();
  const shareUrl = generateUrl(currentRoute.path, currentRoute.params);

  return (
    <Fragment>
      <LinkedinShareButton
        url={shareUrl}
        title={title}
        windowWidth={750}
        windowHeight={600}
        aria-label="linkedin-share"
      >
        <div className="share-button">
          <Icon name="linkedin" aria-hidden={'true'} />
        </div>
      </LinkedinShareButton>
      <FacebookShareButton url={shareUrl} aria-label="facebook-share">
        <div className="share-button">
          <Icon name="facebook" aria-hidden={'true'} />
        </div>
      </FacebookShareButton>
      <TwitterShareButton url={shareUrl} title={title} aria-label="twitter-share">
        <div className="share-button">
          <Icon name="twitter" aria-hidden={'true'} />
        </div>
      </TwitterShareButton>
    </Fragment>
  );
};

SocialShare.propTypes = {
  title: PropTypes.string,
};

export default SocialShare;
